import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  CardMedia,
  Tooltip,
  IconButton,
  InputBase,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHomeSlides } from "./UseHomeSlides";
import { UseMyPC } from "../../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../../components/CustomPagination";
import EditIcon from "@mui/icons-material/Edit";
import { deCapitalizeFirstLetter } from "../../../util/Utils";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Container, Draggable } from "react-smooth-dnd";
import { arrayMove } from "react-sortable-hoc";
import CancelIcon from "@mui/icons-material/Cancel";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import HttpsIcon from "@mui/icons-material/Https";

export default function IsSlideTrue(props) {
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetHomeSlides, updateSlide, deleteSlide } = UseHomeSlides();
  const navigate = useNavigate();
  const [removedIndex, setRemovedIndex] = useState();
  const [openDialog, setOpenDialog] = useState({
    show: false,
    model: undefined,
  });

  const onDrop = ({ removedIndex, addedIndex }) => {
    const updater = (items) =>
      arrayMove(items, removedIndex, addedIndex).map((item, idx) => {
        return { ...item, rowIndex: idx + 1 };
      });
    setRemovedIndex(addedIndex + 1);
    props.setSideModel(updater);
  };

  useEffect(() => {
    if (props.sideModel && removedIndex) {
      let send = {
        Id: "",
        RowIndex: "",
        isActive: true,
        startDate: undefined,
        endDate: undefined,
      };
      let newModel = props.sideModel.find((m) => m.rowIndex == removedIndex);
      send.Id = newModel.id;
      send.RowIndex = props.sideModel.length - newModel.rowIndex + 1;
      send.isActive = newModel.isActive;
      send.startDate = newModel.startDate;
      send.endDate = newModel.endDate;
      updateSlide(send, "", "", (call) => {
        props.callback();
        setRemovedIndex(undefined);
      });
    }
  }, [removedIndex]);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography color="secondary" variant="subtitle1">
          اسلایدهای کناری درحال اکران
        </Typography>
        {props.sideModel && props.sideModel.length ? (
          <Container
            onDrop={onDrop}
            orientation="horizontal"
            behaviour="move"
            style={{
              width: "100% !important",
              direction: "ltr",
              display: "flex",
              justifyContent: "flex-end",
            }}
            dropPlaceholder={{
              animationDuration: 150,
              showOnTop: true,
              className: "cards-drop-preview",
            }}
          >
            {props.sideModel.map((model, i) => {
              return (
                <Draggable
                  key={model.id}
                  style={{
                    width: "13%",
                    cursor: "grab",
                  }}
                  order={model.rowIndex}
                >
                  <Box
                    sx={{
                      mb: 3,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        border: "1px solid #d9d9d9",
                        borderRadius: 3,
                        position: "relative",
                        my: 1,
                        p: 1,
                        pb: 0,
                        mr: 1,
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <LazyLoadImage
                        height="auto"
                        effect="blur"
                        src={
                          model.image2
                            ? model.image2
                            : "/static/img/nobanner.png"
                        }
                        width="100%"
                      />
                      {model.isFix && (
                        <Box
                          sx={{
                            position: "absolute",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            zIndex: 1000,
                            right: -5,
                            top: -5,
                            width: "100% !important",
                            height: "100%",
                            m: 1,
                          }}
                        >
                          <HttpsIcon
                            // fontSize="small"
                            sx={{
                              bgcolor: "primary.main",
                              borderRadius: 50,
                              color: "#fff",
                              cursor: "pointer",
                              p: 0.4,
                            }}
                          />
                        </Box>
                      )}
                      <Box
                        sx={{
                          position: "absolute",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          zIndex: 1000,
                          left: 5,
                          width: "100% !important",
                          height: "100%",
                          m: 0.5,
                        }}
                      >
                        <EditIcon
                          onClick={() => {
                            return navigate("/SlidesManage/editSlide", {
                              state: {
                                // myPc: myPc,
                                // search: search,
                                SlideID: location.state.SlideID,
                                oneSlideID: model.id,
                                componentFaTitle:
                                  location.state.componentFaTitle,
                                ComponentID: location.state?.ComponentID,
                              },
                            });
                          }}
                          // fontSize="small"
                          sx={{
                            bgcolor: "secondary.main",
                            borderRadius: 50,
                            color: "#fff",
                            cursor: "pointer",
                            p: 0.4,
                            ml: 0.5,
                          }}
                        />
                        <CloseIcon
                          onClick={() =>
                            deleteSlide(model.id, () => props.callback())
                          }
                          sx={{
                            bgcolor: "secondary.main",
                            borderRadius: 50,
                            color: "#fff",
                            cursor: "pointer",
                            p: 0.4,
                          }}
                        />
                      </Box>
                    </Box>
                    <Typography variant="subtitle2">{model.id}</Typography>
                  </Box>
                </Draggable>
              );
            })}
          </Container>
        ) : (
          <Box
            width="100px"
            height="100px"
            sx={{
              border: "1px solid #d9d9d9",
              p: 1,
              borderRadius: 3,
              my: 1,
              mb: 3,
              mr: 1,
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <CardMedia
              width="100%"
              component="img"
              image="/static/img/nobanner.png"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}
